<template>
  <dx-broker-offer-intro product="p-move" />
</template>

<script>
import DxBrokerOfferIntro from '~/domains/brokerOffer/components/DX-BrokerOfferIntro'

export default {
  name: 'BrokerOfferPMoveIntro',
  components: {
    DxBrokerOfferIntro,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/privatrechtsschutz/p-move/antragsstrecke/',
      fr: '/portailpartenaires/protection-juridique-privee/p-move/formulaire-de-demande/',
    },
  },
}
</script>
